import { useEffect } from 'react';
import styled from 'styled-components';

import { Icon } from '~src/components/Icon';
import { Heading } from '~src/components/Typography';

const USPWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const USPEntries = () => {
  const iconProps = { width: 30, height: 30, color: 'white', style: { marginBottom: '8px' } };

  useEffect(function loadTrustPilotWidgetScript() {
    const script = document.createElement('script');

    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.type = 'text/javascript';
    script.async = true;

    document.head.appendChild(script);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '600px',
      }}
    >
      <USPWrapper>
        <Icon.Wrench {...iconProps}></Icon.Wrench>
        <Heading level={2} style={{ whiteSpace: 'noWrap' }} color='light'>
          25 års
        </Heading>
        <Heading color='light' level={4} style={{ textAlign: 'center' }}>
          Ydelsegaranti
        </Heading>
      </USPWrapper>

      <USPWrapper>
        <Icon.Advisor {...iconProps}></Icon.Advisor>
        <Heading level={2} style={{ whiteSpace: 'noWrap' }} color='light'>
          Hjælp
        </Heading>
        <Heading color='light' level={4} style={{ textAlign: 'center' }}>
          fra tilbud til installation
        </Heading>
      </USPWrapper>

      <USPWrapper>
        <div
          className='trustpilot-widget'
          data-locale='da-DK'
          data-template-id='53aa8807dec7e10d38f59f32'
          data-businessunit-id='61df4bc87cf9cd8eb46cda9e'
          data-style-height='100px'
          data-style-width='150px'
          data-theme='dark'
        >
          <a href='https://dk.trustpilot.com/review/bodil.energy' target='_blank' rel='noopener noreferrer'>
            Trustpilot
          </a>
        </div>
      </USPWrapper>
    </div>
  );
};
